import posthog from 'posthog-js/full/no-external';

// Analytics temporarily disabled. Uncomment to enable PostHog tracking.
// const postHogKey = process.env.REACT_APP_POSTHOG_KEY;
// const retryCooldownMs = 3 * 60 * 1000;
// let retryAfter = 0;
//
// if (postHogKey) {
//     // Gate the transport too: before_send does not cover PostHog's retry queue.
//     const sendRequest = posthog._send_request.bind(posthog);
//     let retryTimer: ReturnType<typeof setTimeout> | undefined;
//
//     posthog._send_request = (options) => {
//         const isEventRequest = new URL(options.url).pathname.replace(/\/$/, '').endsWith('/e');
//         if (!isEventRequest) {
//             sendRequest(options);
//             return;
//         }
//
//         const remainingCooldown = retryAfter - Date.now();
//         if (remainingCooldown > 0) {
//             // Retain one retry, dropping other batches while the service is down.
//             if (retryTimer === undefined) {
//                 retryTimer = setTimeout(() => {
//                     retryTimer = undefined;
//                     posthog._send_request(options);
//                 }, remainingCooldown);
//             }
//             return;
//         }
//
//         sendRequest({
//             ...options,
//             callback: (response) => {
//                 if (response.statusCode === 0 || response.statusCode >= 500) {
//                     retryAfter = Date.now() + retryCooldownMs;
//                 }
//                 options.callback?.(response);
//             },
//         });
//     };
//
//     posthog.init(postHogKey, {
//         api_host: 'https://analytics.ocean-planner.no',
//         autocapture: false,
//         capture_pageview: 'history_change',
//         capture_pageleave: false,
//         capture_dead_clicks: false,
//         disable_surveys: true,
//         capture_performance: false,
//         disable_external_dependency_loading: true,
//         before_send: (event) => Date.now() < retryAfter ? null : event,
//     });
// }

export default posthog;
